<template>
  <div class="row pl-5 pr-5">
    <h1 class="page-header">My Profile Parameters</h1>
    <div>
      <!-- <app-verify-phone></app-verify-phone> -->
    </div>
    <div class="table-responsive">
      <table class="table table-hover table-striped">
        <tr>
          <th>Name</th>
          <th>Value</th>
        </tr>
        <tr v-for="(v,k) of attributes" :key="k">
          <td>{{ k }}</td>
          <td>{{ v }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="css" scoped>
</style>

<script>
export default {
  Name: "Profile",
  computed: {
    attributes() {
      return this.$store.state.userAttrs.attributes;
    }
  },
  methods: {}
};
</script>